<template>
  <div class="AccreditTest">
    <el-form :inline="true" ref="formScreen" :model="formScreen">
      <el-form-item
        label="选择分公司"
        prop="branchCompany"
        v-if="[1].includes(type)"
      >
        <el-select
          v-model="formScreen.branchCompany"
          placeholder="请选择"
          @change="selectChange($event, 'sonCompany')"
          value-key="company_id"
          filterable
        >
          <el-option
            v-for="item in branchCompany"
            :key="item.company_id"
            :label="item.companyName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="选择子公司"
        prop="sonCompany"
        v-if="[2, 1].includes(type)"
      >
        <el-select
          v-model="formScreen.sonCompany"
          placeholder="请选择"
          value-key="rid"
          @change="selectChange($event, 'branchDepartmentList')"
          filterable
        >
          <el-option
            v-for="item in sonCompany"
            :key="item.company_id"
            :label="item.companyName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择独立站分部门" prop="branchDepartmentValue">
        <el-select
          v-model="formScreen.branchDepartmentValue"
          placeholder="请选择"
          @change="selectChange($event, 'groupList')"
          value-key="rid"
        >
          <el-option
            v-for="item in branchDepartmentList"
            :key="item.value"
            :label="item.departmentName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择组" prop="groupValue">
        <el-select
          v-model="formScreen.groupValue"
          placeholder="请选择"
          @change="selectChange($event, 'userList')"
          value-key="rid"
        >
          <el-option
            v-for="item in groupList"
            :key="item.value"
            :label="item.groupName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择角色" prop="userValue">
        <el-select
          v-model="formScreen.userValue"
          placeholder="请选择"
          @change="selectChange($event)"
          value-key="rid"
        >
          <el-option
            v-for="item in userList"
            :key="item.value"
            :label="item.roleUserName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择活跃状态" prop="active">
        <el-select v-model="active" clearable placeholder="请选择">
          <el-option label="活跃" :value="1"></el-option>
          <el-option label="下架" :value="0"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择店铺状态" prop="state">
				<el-select v-model="state" clearable placeholder="请选择">
					<el-option label="正常" :value="1"></el-option>
					<el-option label="删除" :value="0"></el-option>
				</el-select>
			</el-form-item>

      <el-form-item>
        <el-row>
          <el-input
            v-model="SearchInp"
            placeholder="店铺名称、商铺id"
            style="width: 250px"
          ></el-input>
          <el-button
            type="primary"
            @click="Search2"
            size="mini"
            style="margin-left: 10px; padding: 7px 15px"
            >搜索</el-button
          >
          <el-button
            type="primary"
            @click="formScreenReset"
            size="mini"
            style="padding: 7px 15px"
            >重置</el-button
          >
        </el-row>
      </el-form-item>
    </el-form>
    <el-button type="primary" @click="AddList = true">添加</el-button>
    <el-button type="primary" @click="AddName = true" :disabled="isauthobj ? false : true">授权</el-button> 
    <el-button type="primary" @click="toTutorial">shoplazza教程</el-button>
    <div class="ymx_in">
      <el-table
        :data="tableData"
        border
        style="width: 100%; margin-bottom: 50px"
        v-loading="loadingTable"
      >
        <el-table-column
					label="店铺名称"
					align="center"
				>
					<template slot-scope="scope">
						<div>{{scope.row.shop_name}}</div>
						<div v-if="scope.row.sellercolor" :style="{background:scope.row.sellercolor,'padding':'2px 5px','color':'white','display':'inline-block','border-radius':'5px'}">{{scope.row.itemTypeName}}</div>
					</template>
				</el-table-column>
        <el-table-column
          prop="sellerId"
          label="商户ID"
          align="center"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="authorization_time"
          label="授权时间"
        ></el-table-column>
        <el-table-column
          prop="active"
          align="center"
          width="150"
          label="活跃状态"
        >
          <template slot-scope="scope">
            
            <el-switch
              v-model="scope.row.active"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="活跃"
              inactive-text="下架"
              :active-value="1"
              :inactive-value="0"
              @change="handleTableSwitch(scope.row)">
            </el-switch>
            
          </template>
        </el-table-column>
        <el-table-column
					align="center"
					prop="state"
					label="店铺状态"
					width="80"
				>
					<template slot-scope="scope">
						<span :class="scope.row.state == 1 ? 'green-text' : 'red-text'">{{ scope.row.state == 1 ? '正常' : '删除' }}</span>
					</template>
				</el-table-column>
        <el-table-column
          align="center"
          prop="operationName"
          label="运营部/角色"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="purchaseName"
          label="采购人员"
        ></el-table-column>
        <el-table-column
          width="200"
          prop="fenName"
          label="所属分公司"
          align="center"
          v-if="type === 1"
        ></el-table-column>
        <el-table-column
          width="200"
          prop="ziName"
          label="所属子公司"
          align="center"
          v-if="[1, 2].includes(type)"
        ></el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="230"
          align="center"
          v-if="type === 3"
        >
          <template slot-scope="scope">
            <div>
              <el-button
                @click="handleClick(scope.row)"
                type="text"
                size="small"
                >更改店铺信息</el-button
              >
            </div>
            <div>
              <el-button @click="Delete(scope.row)" type="text" size="small"
                >删除</el-button
              >
            </div>
            <div>
              <el-button
                @click="distribution(scope.row)"
                type="text"
                size="small"
                >分配</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          style="margin-right: 200px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[50, 100, 200, 400]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="修改相关信息"
      :visible.sync="EditName"
      width="30%"
      style="margin-top: 20px"
    >
      <div>
        <label style="display: inline-block; width: 100px">名称：</label
        ><el-input
          placeholder="请输入要修改的店铺名称"
          v-model="NameValue1"
          style="margin-top: 10px; width: 70%"
        ></el-input>
        <div style="margin-top:10px;">
          <label style="display: inline-block;width: 100px;">店铺状态：</label>
          <el-radio-group v-model="shopradio">
            <el-radio @click.native.prevent="clickitem(item.itemTypeIdInteger)" v-for="item in shopdata" :label="item.itemTypeIdInteger" :key="item.itemTypeIdInteger">{{item.itemTypeName}}</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="EditName = false">取 消</el-button>
        <el-button type="primary" @click="Submit">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="店铺分配"
      :visible.sync="shopDistribution"
      width="25%"
      style="margin-top: 20px"
    >
      <el-form class="custom-form" ref="form" label-width="100px" label="left">
        <el-form-item label="选择部门">
          <el-select v-model="value1" @change="choose1" placeholder="请选择">
            <el-option
              v-for="item1 in this.arr1"
              :key="item1.value"
              :label="item1.departmentName"
              :value="item1"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择分部门" v-show="isShow">
          <el-select v-model="value2" @change="choose2" placeholder="请选择">
            <el-option
              v-for="item2 in this.arr2"
              :key="item2.value"
              :label="item2.departmentName"
              :value="item2"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择组" v-show="isShow">
          <el-select v-model="value3" @change="choose3" placeholder="请选择">
            <el-option
              v-for="item3 in this.arr3"
              :key="item3.value"
              :label="item3.groupName"
              :value="item3"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择员工">
          <el-select v-model="value4" @change="choose4" placeholder="请选择">
            <el-option
              v-for="item4 in this.arr4"
              :key="item4.value"
              :label="item4.roleName"
              :value="item4"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="shopDistribution = false">取消</el-button>
        <el-button type="primary" @click="Submit1" :loading="loadingStatus"
          >分配</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="shoplazza授权"
      :visible.sync="AddName"
      width="30%"
      style="margin-top: 20px"
    >
      <div>
        <label style="display: inline-block; width: 100px">店铺名称：</label>
        <el-input
          placeholder="请输入要授权的店铺名称"
          v-model="NameStore"
          style="margin-top: 10px; width: 70%"
        ></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="AddName = false">取 消</el-button>
        <el-button type="primary" @click="SubmitSave">授 权</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="新增shoplazza授权"
      :visible.sync="AddList"
      width="30%"
      style="margin-top: 20px"
      @close="closeDialog"
    >
      <div>
        <!-- <label style="display: inline-block; width: 100px">店铺名称：</label
        ><el-input
          placeholder="请输入店铺名称"
          v-model="StoreNames"
          style="margin-top: 10px; width: 70%"
        ></el-input> -->
        <label style="display: inline-block; width: 100px">店铺域名：</label
        ><el-input
          placeholder="请输入店铺域名"
          v-model="StoreID"
          style="margin-top: 10px; width: 70%"
        ></el-input>
        <label style="display: inline-block;width: 100px;height: 60px;float: left;"></label
				>
				<span style="color: red;width: 70%;margin-top: 10px;display: block;float: left;">
					示例：店铺链接为https://acaxun.myshoplaza.com,只需输入acaxun即可;
				</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="AddList = false">取 消</el-button>
        <el-button type="primary" @click="SubmitSave1">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { ajaxGet, ajaxPost, Baseurl } from "../../api/api/api";
import { mapState } from 'vuex'
export default {
  name: "ShoplazzaAuthorize",
  components: {},
  props: {},
  data() {
    return {
      active: "",
      SearchInp: "",
      formScreen: {
        branchCompany: {},
        sonCompany: {},
        departmentValue: {},
        branchDepartmentValue: {},
        groupValue: {},
        userValue: {},
      },
      branchCompany: [],
      sonCompany: [],
      branchDepartmentList: [],
      groupList: [],
      userList: [],
      str: "",
      type: "",
      companyId: "",
      staffId: "",
      System: "",
      currentPage: 1,
      pagesize: 50,
      size: 50,
      total: 0,
      tableData: [],
      loadingTable: false,
      EditName: false,
      sellerId1: "",
      NameValue1: "",
      mwsAuthTokenValue1: "",
      amazon_id1: "",
      developerId: "",
      sid: "",
      gid: "",
      rid: "",
      arr1: "",
      arr2: "",
      arr3: "",
      arr4: "",
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      NameStore: "",
      loadingStatus: false,
      shopDistribution: false,
      isShow: true,
      AddName: false,
      AddList: false,
      StoreNames: "",
      StoreID: "",
      isauthobj: true,
      //店铺信息
			shopdata:[],
			//选中的店铺信息
			shopradio:'',
      state: '',
    };
  },

  computed: {
    ...mapState({
        role: state => state.user.role,
    })
  },

  watch: {
    role: {
        handler(newVal) {
            this.reset();
        },
        deep: true,
    },
  },
  created() {
    this.reset();
  },
  mounted() {},
  methods: {
    reset(){
        this.str = this.role;
        if (this.str == null) {
            return false;
        } else {
            this.type = this.str.type;
            this.init();
            this.tableList();
        }
        // console.log(this.str);
        //请求店铺信息
        ajaxPost(
            Baseurl + 'purchaseController/selectItemList',
            {
                "itemCode": "HYXUN0000015"
            }
        ).then((res) => {
            const { code, data } = res.data
            if (code === 200) {
                this.shopdata = res.data.data;
            }
        })
    },
    handleTableSwitch(item) {
      const API = Baseurl + 'sellerController/updateSellerInfoActive'
      const paramsData = { 
        id: item.id,
        active: item.active
      }
      console.log(paramsData);
      // paramsData.id = item.id
      // paramsData.priority = item.priority

      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.$message.success('操作成功')
        } else {
          this.Search2()
          this.$message.error(data)
        }
      })
    },
    clickitem(e) {
			e === this.shopradio ? this.shopradio = '' : this.shopradio = e
		},
    toTutorial() {
			window.open('https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/shoplazza%E6%8E%88%E6%9D%83%E6%95%99%E7%A8%8B.pdf')
		},
    closeDialog() {
      this.StoreNames = "";
      this.StoreID = "";
    },
    SubmitSave1() {
      // const API = Baseurl + "seller/addSellerInfo";
      // const paramsData = {
      //   shopName: this.StoreNames,
      //   companyId: this.companyId,
      //   sellerId: this.StoreID,
      //   sellerType: 5,
      // };
      // ajaxPost(API, paramsData).then((res) => {
      //   if (res.data.code === 1) {
      //     this.$message.success("添加成功！");
      //     this.AddList = false;
      //     this.tableList();
      //   }
      // });
      // console.log(state);
      var state=this.randomString(256);
      var url=`https://${this.StoreID}.myshoplaza.com/admin/oauth/authorize?client_id=abKz8ywmtPNAx87AlGBnpbJyC-BiL2qKWXr4Tze_E1o&scope=read_product write_product read_order write_order read_shop read_customer read_script_tags read_price_rules read_data write_data&redirect_uri=https://haihuiselling.com/&response_type=code`;
      if(this.StoreID===''){
				this.$message.error('请输入店铺域名！');
			}else{
				this.AddList = false
				// str=str+this.StoreNames;
				localStorage.setItem("state", state);
        // localStorage.setItem("ShooplazzaStoreNames", StoreName);
				setTimeout(function(){
					window.open(url,'_self');
				},1000)
			}
    },
		randomString(e) {
			e = e || 32
			var t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz123456780',
				a = t.length,
				n = ''
			for (let i = 0; i < e; i++)
				n += t.charAt(Math.floor(Math.random() * a))
			return n
		},
    selectChange(item, type) {
      const { rid, system, company_id: companyId } = item;
      companyId && (this.companyId = companyId);
      this.getNextPower(rid, system, type);
      if (type === "sonCompany") {
        this.formScreen.sonCompany = {};
        this.formScreen.departmentValue = {};
        this.formScreen.groupValue = {};
        this.sonCompany = [];
        this.departmentList = [];
        this.groupList = [];
      } else if (type === "departmentList") {
        this.formScreen.departmentValue = {};
        this.formScreen.branchDepartmentValue = {};
        this.formScreen.groupValue = {};
        this.departmentList = [];
        this.branchDepartmentList = [];
        this.groupList = [];
      } else if (type === "branchDepartmentList") {
        this.formScreen.branchDepartmentValue = {};
        this.formScreen.groupValue = {};
        this.branchDepartmentList = [];
        this.groupList = [];
      } else if (type === "groupList") {
        this.formScreen.groupValue = {};
        this.formScreen.userValue = {};
        this.groupList = [];
        this.userList = [];
      } else if (type === "userList") {
        this.formScreen.userValue = {};
        this.userList = [];
      }
      this.staffId = rid;
      this.System = system;
    },
    init() {
      const {
        rid,
        system,
        company_id: companyId,
        type: companyType,
      } = this.str;
      this.companyId = companyId;
      this.staffId = rid;
      this.System = system;
      let type = "";
      if (companyType === 1) {
        type = "branchCompany";
      } else if (companyType === 2) {
        type = "sonCompany";
      } else if (system < 3) {
        type = "branchDepartmentList";
      } else if (system === 3) {
        type = "groupList";
      } else {
        return;
      }
      this.getNextPower(rid, system, type);
    },
    getNextPower(rid, system, type) {
      const API = Baseurl + "roleController/selectNextInfoByRid";
      const paramsData = {
        rid,
        system,
        companyId: this.companyId,
        sellerType: 5,
      };
      ajaxPost(API, paramsData)
        .then((res) => {
          const {
            data: { code, data },
          } = res;
          if (code === 200) {
            this[type] = data.next;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    Search2() {
      this.currentPage = 1;
      this.tableList();
    },
    tableList() {
      var obj=localStorage.getItem("authobj");
      // console.log(obj);
      if(obj){
        this.isauthobj=true;
      }else{
        this.isauthobj=false;
      }
      var that=this;
      setTimeout(function(){
        that.isauthobj=false;
        // console.log('iiiii')
      },5*1000*60)
      this.loadingTable = true;
      const paramsData = {
        isSpapiAuthorize: 0,
        sellerType: 5,
        page: this.currentPage,
        size: this.size,
        company_id: this.companyId,
        rid: this.staffId,
        system: this.System,
        searchString: this.SearchInp,
        active: this.active,
        state: this.state,
      };
      ajaxPost(
        Baseurl + "sellerController/selectSellerListByRid",
        paramsData
      ).then((res) => {
        const { code, data } = res.data;
        this.loadingTable = false;
        if (code === 200) {
          const {
            next = [],
            sellerInfo: { list, total },
          } = data;
          // this[type] = next
          this.tableData = list;
          this.total = total;
          this.tableCountry = [];
          for (var i = 0; i < list.length; i++) {
            this.tableCountry.push(list[i].countryMarks);
          }
          for (var j = 0; j < this.tableData.length; j++) {
						if(this.tableData[j].sellerMark!==null){
							for (var a = 0; a < this.shopdata.length; a++){
								if(this.tableData[j].sellerMark===Number(this.shopdata[a].itemTypeIdInteger)){
									this.tableData[j].sellercolor=this.shopdata[a].itemName;
									this.tableData[j].itemTypeName=this.shopdata[a].itemTypeName;
								}
							}
						}
					}
					// console.log(this.tableData);
        }
        // console.log(this.tableData)
      });
    },
    SubmitSave() {
      // console.log(localStorage.getItem("authobj"))
      var obj={
        code:JSON.parse(localStorage.getItem("authobj")).code,
        hmac:JSON.parse(localStorage.getItem("authobj")).hmac,
        shop:JSON.parse(localStorage.getItem("authobj")).shop,
        companyId:JSON.parse(localStorage.getItem("role")).company_id,
        shopName:this.NameStore
      }
      // console.log(obj)
      const API = Baseurl + "/shoplazza/authorization";
      ajaxPost(API,obj).then(
        (res) => {
          if (res.data.code == 1) {
            this.$message({
              message: "授权成功",
              type: "success",
            });
            this.AddName=false;
            this.isauthobj=false;
            this.tableList();
            window.localStorage.removeItem("authobj")
          } else {
            this.$message.error(res.data.message);
          }
          this.AddName=false;
          this.isauthobj=false;
          window.localStorage.removeItem("authobj")
          this.tableList();
        }).catch(() => {
          this.$message.error('第三方报错，请重新走流程。');
          this.AddName=false;
          this.isauthobj=false;
          window.localStorage.removeItem("authobj")
          this.tableList();
        });
    },
    handleClick(item) {
      this.EditName = true;
      // console.log(JSON.parse(JSON.stringify(item)))
      // item.countryMarks.area
      // IOSS
      // item.countryMarks.forEach((val) => {
      // 	if (val.area == 'EUR') {
      // 		this.IOSS = true
      // 	} else {
      // 		this.IOSS = false
      // 	}
      // })
      // this.iossCode = item.iossCode
      this.sellerId1 = item.sellerId;
      this.NameValue1 = item.shop_name;
      this.mwsAuthTokenValue1 = item.mwsAuthToken;
      this.amazon_id1 = item.amazon_id;
      this.developerId = item.developerId;
       this.shopradio=item.sellerMark?.toString();
    },
    Submit() {
      // console.log()
      // return
      // if (this.IOSS) {
      // 	let str = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{12}$/
      // 	if (!str.test(this.iossCode)) {
      // 		this.$message.error('IOSS格式为12位字母+数字组合')
      // 		return
      // 	}
      // }

      var obj = {
        sellerId: this.sellerId1,
        shop_name: this.NameValue1,
        mwsAuthToken: this.mwsAuthTokenValue1,
        developerId: this.developerId,
        sellerMark:this.shopradio
        // iossCode: this.iossCode,
      };
      ajaxPost(Baseurl + "sellerController/updateShopNameBySellerId", obj).then(
        (res) => {
          // console.log(res.data)
          if (res.data.code == 200) {
            this.$message({
              message: "修改店铺名成功",
              type: "success",
            });
            this.tableList();
          } else {
            this.$message.error(res.data.data);
          }
        }
      );
      this.NameValue = "";
      this.shopradio='';
      this.EditName = false;
    },
    Delete(item) {
      // console.log(item)
      this.$confirm("确认删除此条数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var obj = { id: item.id };
          ajaxPost(Baseurl + "sellerController/deleteSellerInfo", obj).then(
            (res) => {
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.tableList();
              } else {
                this.$message.error("删除失败");
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    distribution(val) {
      // console.log(val)
      this.sid = val.id;
      this.shopDistribution = true;
      var company_id = {
        company_id: this.companyId,
        sellerType: 5,
      };
      ajaxPost(
        Baseurl + "roleController/selectDepartmentByCompanyId",
        company_id
      ).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.arr1 = res.data.data;
        }
      });
    },
    choose1(val) {
      this.departmentId = val.did;
      // console.log(val)
      this.arr2 = [];
      this.arr3 = [];
      this.arr4 = [];
      this.value2 = "";
      this.value3 = "";
      this.value4 = "";

      if (val.kind === 0) {
        this.isShow = true;
        var company_id = {
          dgrId: val.dgrId,
          system: 2,
        };
        ajaxPost(
          Baseurl + "roleController/selectNextInfoByDgrId",
          company_id
        ).then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            this.arr2 = res.data.data.next;
          }
        });
      } else if (val.kind === 1) {
        this.departmentChildId = "";
        this.gid = "";
        this.isShow = false;
        var company_id = {
          dgrId: val.dgrId,
          system: 2,
        };
        ajaxPost(
          Baseurl + "roleController/selectNextInfoByDgrId",
          company_id
        ).then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            this.arr4 = res.data.data.next;
          }
        });
      }
    },
    choose2(val) {
      this.departmentChildId = val.did;
      // console.log(val)
      this.arr3 = [];
      this.arr4 = [];
      this.value3 = "";
      this.value4 = "";
      var company_id = {
        dgrId: val.dgrId,
        system: 3,
      };
      ajaxPost(
        Baseurl + "roleController/selectNextInfoByDgrId",
        company_id
      ).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.arr3 = res.data.data.next;
        }
      });
    },
    choose3(val) {
      this.gid = val.gid;
      // console.log(val)
      this.arr4 = [];
      this.value4 = "";
      var company_id = {
        dgrId: val.dgrId,
        system: 4,
      };
      ajaxPost(
        Baseurl + "roleController/selectNextInfoByDgrId",
        company_id
      ).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.arr4 = res.data.data.next;
        }
      });
    },
    choose4(val) {
      this.rid = val.rid;
      // console.log(val)
    },
    Submit1() {
      this.$confirm("是否分配该店铺当前时间之前的所有订单", "提示", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning",
      })
        .then(() => {
          this.isAccept = 1;
          this.submitAjax();
        })
        .catch(() => {
          this.isAccept = 0;
          this.submitAjax();
        });
    },
    submitAjax() {
      var obj = {
        departmentId: this.departmentId,
        departmentChildId: this.departmentChildId,
        gid: this.gid,
        rid: this.rid,
        sid: this.sid,
        isAccept: this.isAccept,
      };
      // console.log(obj);
      this.loadingStatus = true;
      ajaxPost(Baseurl + "sellerController/allotSeller", obj).then((res) => {
        this.loadingStatus = false;
        if (res.data.code == 200) {
          this.$message({
            message: "分配店铺成功",
            type: "success",
          });
          this.tableList();
          this.shopDistribution = false;
        } else {
          this.$message.error(res.data.data);
        }
      });
    },
    handleSizeChange(val) {
      this.size = val;
      this.tableList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.tableList();
    },
    formScreenReset() {
      this.currentPage = 1;
      this.$refs.formScreen.resetFields();
      this.branchCompany = [];
      this.sonCompany = [];
      this.departmentList = [];
      this.branchDepartmentList = [];
      this.groupList = [];
      this.userList = [];
      this.SearchInp = "";
      this.staffId = this.str.rid;
      this.System = this.str.system;
      this.state = '';
      this.tableList();
      this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
.AccreditTest {
  width: 98%;
  .el-button {
    padding: 9px 15px;
  }
  .el-table {
    margin-top: 20px;
  }
  .page {
    position: fixed;
    width: 100%;
    bottom: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
  }
}
.green-text {
	color: #67c23a;
}

.red-text {
	color: #f56c6c;
}
</style>